<template>
  <div class="e-extra-as-badge">
    <div class="form-check">
      <input
        :id="'radioRequired' + item.optionId"
        :name="'radioGroup' + index"
        class="form-check-input"
        type="radio"
        :value="item.optionId"
        :checked="modelValue === item.optionId"
        @change="$emit('update:modelValue', item.optionId)" />
      <label class="form-check-label" :for="'radioRequired' + item.optionId">
        <div>
          <span v-if="item.optionCode">{{ item.optionCode }}&nbsp;-</span>
          {{ item.name }} -
          <i>[{{ item.optionId }}]</i>
        </div>
        <strong v-if="item.price">:&nbsp;€{{ calculatedPrice }}</strong>
      </label>
    </div>
  </div>
</template>

<script>
import * as lib from './../../../lib/lib'

export default {
  props: {
    index: {
      required: true,
      type: Number,
    },
    id: {
      required: true,
      type: String,
    },
    options: {
      required: true,
      type: Array,
    },
    /* eslint-disable vue/require-default-prop */
    modelValue: String,
  },
  emits: ['update:modelValue'],
  data() {
    return {
      lang: 'en',
    }
  },
  computed: {
    item() {
      return this.options.find((x) => x.optionId === this.id)
    },
    calculatedPrice() {
      if (!this.configuration.vat) {
        return this.item.price.toLocaleString(this.lang)
      }
      const vat = this.configuration.vat / 100 + 1
      return (this.item.price * vat).toLocaleString(this.lang)
    },
  },
  mounted() {
    this.lang = lib.getLocaleFromLangAttr()
  },
}
</script>
